/* eslint-disable */
import Badge from '@cavilha/badge';
import Icon from '@cavilha/icon';
import Text from '@cavilha/text';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons/faChevronLeft';
import { useListFilter } from 'hooks/algolia/useListFilter';
import { useMemo, useState } from 'react';
import { connectHierarchicalMenu } from 'react-instantsearch-dom';

type HierarchicalMenuItem = {
  label: string;
  value: string;
  count: number;
  isRefined: boolean;
  items?: HierarchicalMenuItem[];
};

type HierarchicalMenuProps = {
  items: HierarchicalMenuItem[];
  refine: Function;
  limit?: number;
  showMore?: boolean;
  showMoreLimit?: number;
};

export const HierarchicalDesktop = ({
  items,
  refine,
  limit = 8,
  showMore = true,
  showMoreLimit = 24,
}: HierarchicalMenuProps): JSX.Element => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const [itemsLimit, setItemsLimit] = useState<number>(limit);

  const { trackListFilter } = useListFilter();

  const { itemsToShow, showButton } = useMemo(() => {
    const refinedItems = items
      .sort((a, b) => b.count - a.count)
      .filter(item => {
        return item.isRefined === true;
      });

    if (refinedItems.length > 0) {
      return {
        itemsToShow: refinedItems,
        showButton: false,
      };
    }

    return {
      itemsToShow: items,
      showButton: showMore,
    };
  }, [items, showMore]);

  return (
    <>
      <ul>
        {itemsToShow.slice(0, itemsLimit).map(item => {
          return (
            <li key={item.label}>
              <Text
                as="a"
                href="#"
                css={{
                  textDecoration: 'none',
                  mb: '$small3',
                  display: 'flex',
                  alignItems: 'center',
                }}
                onClick={event => {
                  event.preventDefault();
                  trackListFilter({
                    typeName: 'Categoria',
                    elementPosition: 1,
                    elementName: item.label,
                  });
                  refine(item.value);
                }}
              >
                {item.isRefined && (
                  <Icon
                    icon={faChevronLeft}
                    iconSize={14}
                    css={{ color: '$neutral6', mr: '$small2' }}
                  />
                )}

                <Text
                  as="span"
                  size="bodySmall"
                  css={{ mr: '$small1', color: '$neutral6' }}
                  weight={item.isRefined ? 'bold' : 'regular'}
                >
                  {item.label}
                </Text>

                <Badge
                  css={{ fontSize: '$bodyXSmall' }}
                  count={item.count}
                  overflowCount={100000}
                />
              </Text>

              {item.items && (
                <HierarchicalDesktop
                  items={item.items}
                  refine={refine}
                  limit={24}
                  showMore={false}
                />
              )}
            </li>
          );
        })}
      </ul>

      {showMore && showButton && items.length > limit ? (
        <Text
          as="a"
          textStyle="bodySmallSemibold"
          css={{
            cursor: 'pointer',
            color: '$secondary4',
          }}
          onClick={event => {
            event.preventDefault();
            setIsExpanded(!isExpanded);
            setItemsLimit(isExpanded ? limit : showMoreLimit);
          }}
        >
          {isExpanded ? 'Ver menos' : 'Ver mais'}
        </Text>
      ) : null}
    </>
  );
};

const HierarchicalMobile = ({
  items,
  refine,
  limit = 8,
  showMore = true,
  showMoreLimit = 24,
}: HierarchicalMenuProps): JSX.Element => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const [itemsLimit, setItemsLimit] = useState<number>(limit);

  const { trackListFilter } = useListFilter();

  const { itemsToShow, showButton } = useMemo(() => {
    const refinedItems = items
      .sort((a, b) => b.count - a.count)
      .filter(item => {
        return item.isRefined === true;
      });

    if (refinedItems.length > 0) {
      return {
        itemsToShow: refinedItems,
        showButton: false,
      };
    }

    return {
      itemsToShow: items,
      showButton: showMore,
    };
  }, [items, showMore]);

  return (
    <>
      <ul>
        {itemsToShow.slice(0, itemsLimit).map(item => {
          return (
            <li key={item.label}>
              <Text
                as="a"
                href="#"
                css={{
                  textDecoration: 'none',
                  mb: '$small3',
                  display: 'flex',
                  alignItems: 'center',
                }}
                onClick={event => {
                  event.preventDefault();
                  trackListFilter({
                    typeName: 'Categoria',
                    elementPosition: 1,
                    elementName: item.label,
                  });
                  refine(item.value);
                }}
              >
                {item.isRefined && (
                  <Icon
                    icon={faChevronLeft}
                    iconSize={14}
                    css={{ color: '$neutral6', mr: '$small2' }}
                  />
                )}

                <Text
                  as="span"
                  size="bodySmall"
                  css={{ mr: '$small1', color: '$neutral6' }}
                  weight={item.isRefined ? 'bold' : 'regular'}
                >
                  {item.label}
                </Text>

                <Badge
                  css={{ fontSize: '$bodyXSmall' }}
                  count={item.count}
                  overflowCount={100000}
                />
              </Text>

              {item.items && (
                <HierarchicalMobile
                  items={item.items}
                  refine={refine}
                  limit={24}
                  showMore={false}
                />
              )}
            </li>
          );
        })}
      </ul>

      {showMore && showButton && items.length > limit ? (
        <Text
          as="a"
          textStyle="bodySmallSemibold"
          css={{
            cursor: 'pointer',
            color: '$secondary4',
          }}
          onClick={event => {
            event.preventDefault();
            setIsExpanded(!isExpanded);
            setItemsLimit(isExpanded ? limit : showMoreLimit);
          }}
        >
          {isExpanded ? 'Ver menos' : 'Ver mais'}
        </Text>
      ) : null}
    </>
  );
};

export const HierarchicalMenuDesktop = connectHierarchicalMenu(HierarchicalDesktop);
export const HierarchicalMenuMobile = connectHierarchicalMenu(HierarchicalMobile);
/* eslint-enable */
